module.exports = __webpack_public_path__ + "static/media/goods_bg_active.cc2c3372.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods_bg_active.png
// module id = 415
// module chunks = 0